import React, { useMemo, useState } from 'react'
import { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { addLocale } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types'
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import dateFormat from '../../services/DateFormat.service';
import apis from '../../api';
import { useRef } from 'react';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import useWindowDimensions from '../hooks/useDimensions';
import {
    Calendar as BigCalendar,
    Views,
    DateLocalizer,
    momentLocalizer,
} from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toolbar as BigToolbar } from 'react-big-calendar/lib/Toolbar';
import InfoIcon from '../InfoIcon/InfoIcon';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Documents.css'
import { ScrollPanel } from 'primereact/scrollpanel';
import { TreeTable } from 'primereact/treetable';
import { Carousel } from 'primereact/carousel';
import Maps from '../Maps/Maps'
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import Maps2 from '../Maps/Maps2';
import Webcam from 'react-webcam';
import { Image } from 'primereact/image';
import fileToBase64 from '../../services/fileToBase64';
import { FileUpload } from 'primereact/fileupload';
import { useLocation } from '../Maps/LocationContext';
import Places from '../Maps/Places';
import { Checkbox } from 'primereact/checkbox';
import { Badge } from 'primereact/badge';
import { Message } from 'primereact/message';
import { MultiSelect } from 'primereact/multiselect';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Galleria } from 'primereact/galleria';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TablePaginator } from '../TablePaginator/TablePaginator';

const Documents = () => {

    const [fechaInicio, setFechaInicio] = useState("")
    const [fechaInicioNov, setFechaInicioNov] = useState(new Date(Date.now()))
    const [novedadesCalendario, setNovedadesCalendario] = useState([])

    const [docTypeList, setDocTypeList] = useState([])
    const [docType, setDocType] = useState("")
    const [docId, setDocId] = useState("")
    const [docUrl, setDocUrl] = useState("")
    const [files, setFiles] = useState("")

    const [loading1, setLoading1] = useState(false)
    const [loadPage, setLoadPage] = useState(false)

    const toast = useRef(null);
    const elementWidth = { width: "20rem" }
    const headers = {
        authorization: localStorage.getItem('token')
    }

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    /*Propiedades de la tabla del componente*/
    const [registros, setRegistros] = useState([]);

    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading4, setLoading4] = useState(false)

    const [existingDocs, setExistingDocs] = useState([])

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [isOpenDownload, setIsOpenDownload] = useState(false)
    const [isOpenConf, setIsOpenConf] = useState(false)

    const [selectedNodeKeys, setSelectedNodeKeys] = useState(null);

    const labelStyle = {
        display: "block",
        float: "left",
        marginTop: "5px",
        width: "100%",
        paddingTop: "5px"
    }

    const fileUploadRef = useRef(null);

    const [rows, setRows] = useState([]);
    const [products, setProducts] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [retry, setRetry] = useState(false)

    const { width, height } = useWindowDimensions()

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    const hideModal = () => {
        setIsOpen(false);
        limpiar();
    };

    const showModal = () => {
        setIsOpen(true);
    };

    const showModalDelete = () => {
        setIsOpenDelete(true);
    };

    const hideModalDelete = () => {
        setIsOpenDelete(false);
        limpiar();
    };

    const showModalDownload = () => {
        setIsOpenDownload(true);
    };

    const hideModalDownload = () => {
        setIsOpenDownload(false);
        limpiar()
    };

    const showModalConf = () => {
        setIsOpenConf(true);
    };

    const hideModalConf = () => {
        setIsOpenConf(false);
    };

    useEffect(() => {
        setTable()
    }, [])

    useEffect(() => {
        getDocTypeList()
    }, [])

    async function limpiar() {
        setDocId("")
        setDocType("")
        setDocUrl("")
        setFiles([])
        setExistingDocs([])
    }

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = TablePaginator()

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} disabled={!filters1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm" style={{ width: '6rem' }} value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NOVELTY_DESC': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const onSelection = (e) => {
        setSelectedNodeKeys(e.value)
        let keys = Object.keys(e.value)
        console.log(keys)
        let selected = []
        rows.forEach(row => {
            if (row.children.length > 0) {
                row.children.forEach(child => {
                    if (keys.includes(child.key)) {
                        console.log(child.key)
                        selected.push(child)
                    }
                })
            }
        })
        console.log(selected)
        setRegistros(selected)
    }

    const getDocTypeList = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')

        try {
            await apis.getDocumentList(_entity, _client, headers).then(res => {
                let list = res.data.TIPOS_ARCHIVO
                setDocTypeList(list)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const setTable = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _number_id = localStorage.getItem('number_id')

        try {
            await apis.getDocuments(_entity, _client, _number_id, headers).then(res => {
                let data = res.data.DOCUMENTS
                let newData = []
                data.forEach(person => {
                    let p = person
                    let newChildren = []
                    person.children.forEach(file => {
                        let f = file
                        f.data = {
                            ...f.data,
                            NUMBER_ID: f.data.DOCUMENT_ID,
                            NAME: f.data.NAME_FILE
                        }
                        newChildren.push(f)
                    })
                    p = {
                        ...p,
                        children: newChildren
                    }
                    newData.push(p)
                })
                console.log(newData)
                setRows(newData)
                setLoadPage(true)
            })
        }
        catch (err) {
            setLoadPage(true)
            console.log(err)
        }
    }

    const postDoc = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _number_id = localStorage.getItem('number_id')
        const _docType = docType.detail_id

        let _docExt = ""
        let _docString = ""

        if (files.length > 0) {
            let _file = files[0]
            let _ext = _file.name.split('.')
            console.log(_ext)
            let base64 = ""

            await fileToBase64(_file).then(res => {
                base64 = res
                base64 = base64.split(',')
            })

            _docExt = _ext[_ext.length - 1]
            _docString = base64[1]
        }

        const payload = {
            ENTITY: _entity,
            CLIENT: _client,
            NUMBER_ID: _number_id,
            LOV_DOCUMENT_TYPE: _docType,
            EXT: _docExt,
            IMAGE: _docString
        }

        try {
            await apis.postDocument(payload, headers).then(res => {
                const msg = res.data.DOCUMENTS[0].data.MESSAGE ? res.data.DOCUMENTS[0].data.MESSAGE : "Documento agregado exitosamente"
                setLoading1(false)
                setLoading4(false)
                setTable()
                hideModal()
                hideModalConf()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: msg });
            })
        }
        catch (err) {
            setLoading1(false)
            setLoading4(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const deleteDoc = async () => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _docId = docId

        try {
            await apis.delDocument(_entity, _client, _docId, headers).then(res => {
                setLoading2(false)
                setTable()
                hideModalDelete()
                toast.current.show({ severity: 'info', summary: 'Información', detail: 'Documento eliminado exitosamente' });
            })
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const getDocUrl = async (id) => {
        setLoading3(true)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _docId = id

        try {
            await apis.getDocumentUrl(_entity, _client, _docId, headers).then(res => {
                let url = res.data.IMAGE
                setDocUrl(url)
                setLoading3(false)
            })
        }
        catch (err) {
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const photoBodyTemplate = (rowData) => {
        let photo = rowData.data.IMAGES ? rowData.data.IMAGES : process.env.REACT_APP_PROFILE_PIC
        console.log(rowData.children)
        if (rowData.data.NAME) {
            return (
                <div className='flex flex-row align-items-center justify-content-start gap-1'>
                    <img alt={""} loading='eager' src={photo} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                    <div className='flex flex-column ml-2'>
                        <span className='font-bold'>{rowData.data.NAME}</span>
                        <span>{rowData.data.CONTRACT_ID} - {rowData.data.JOB_ID}</span>
                    </div>
                </div>
            );
        }
    }

    const rowClassName = (node) => {
        return { 'p-highlight': (node.data["DOCUMENT_ID"]) };
    }

    const actionBodyTemplate = (rowData) => {
        if (rowData.children) {
            return (
                <div className='flex flex-row justify-content-center'>
                    <Button icon="pi pi-plus" className="p-button-success mr-2 p-button-sm text-xs" tooltip="Agregar" tooltipOptions={{ position: 'top' }}
                        onClick={() => {
                            setExistingDocs(rowData.children)
                            showModal()
                        }} />
                </div>
            )
        }
        else {
            return (
                <div className='flex flex-row justify-content-center'>
                    <Button icon="pi pi-trash" className="p-button-danger mr-1 p-button-sm text-xs" tooltip="Eliminar" tooltipOptions={{ position: 'top' }}
                        onClick={() => { setDocId(rowData.data.DOCUMENT_ID); showModalDelete() }} />
                    <Button icon="pi pi-download" className="p-button-info mr-1 p-button-sm text-xs" tooltip="Descargar" tooltipOptions={{ position: 'top' }}
                        onClick={() => { getDocUrl(rowData.data.DOCUMENT_ID); showModalDownload() }} />
                </div>
            )
        }
    }

    const validateDocs = () => {
        const validation = existingDocs.find(e => e.data.LOV_DOCUMENT_TYPE_DESC === docType.description)
        if (validation) {
            console.log(validation)
            showModalConf()
        }
        else {
            postDoc()
        }
    }

    const deleteHeader = (
        <div>
            <h3>¿Desea eliminar el documento?</h3>
        </div>
    );

    const deleteFooter = (
        <div>
            <Button onClick={hideModalDelete} label='Cancelar'></Button>
            <Button onClick={() => { setLoading2(true); deleteDoc() }} loading={loading2} label='Eliminar'></Button>
        </div>
    );

    const addFooter = (
        <div>
            <Button onClick={hideModal} label='Cancelar'></Button>
            <Button onClick={() => { setLoading1(true); validateDocs() }} disabled={files.length < 1 || (docType === "" || docType === undefined)} loading={loading1} label='Guardar'></Button>
        </div>
    );

    const addHeader = (
        <div>
            <h3>Agregar documento</h3>
        </div>
    );

    const downloadFooter = (
        docUrl && <div>
            <Button onClick={hideModalDownload} label='Cancelar' disabled={loading3}></Button>
            <Button onClick={() => { window.open(docUrl, "_blank") }} loading={loading3} label='Descargar' icon='pi pi-download'></Button>
        </div>
    );

    const downloadHeader = (
        <div>
            <h3>Descargar documento</h3>
        </div>
    );

    const confFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); setLoading4(false); hideModalConf() }} label='Cancelar'></Button>
            <Button onClick={() => { setLoading4(true); postDoc() }} loading={loading4} label='Confirmar'></Button>
        </div>
    );

    const confHeader = (
        <div>
            <h3>Este documento ya existe,<br />
                ¿desea sobreescribirlo?
            </h3>
        </div>
    );

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8r'>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Documentos</span>
            </div>
            <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <label style={labelStyle} htmlFor="label">Tipo documento</label>
                <Dropdown style={elementWidth} value={docType} autofocus optionLabel='description'
                    filter showClear filterBy="description" emptyMessage={"No hay tipos disponibles"}
                    onChange={(e) => setDocType(e.value)} options={docTypeList} placeholder={docType ? docType.description : 'Seleccione'} />
                <label style={labelStyle} htmlFor="label">Adjunto {docType && `(Debe ser ${docType.code_father})`}</label>
                <div className='flex flex-wrap align-items-center mt-6 gap-2'>
                    <FileUpload disabled={!docType || docType === undefined}
                        mode="basic" name="demo[]" ref={fileUploadRef} accept={docType ? docType.code_father : "*"} maxFileSize={2000000} chooseLabel="Seleccionar" onValidationFail={() => {
                            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                        }}
                        onSelect={(e) => setFiles(e.files)} />
                    <Message severity="info" text="Máx. 2 MB" />
                </div>
            </Dialog>
            <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenDelete} position="top"
                draggable={false} resizable={false} modal onHide={hideModalDelete}>
            </Dialog>
            <Dialog header={downloadHeader} footer={downloadFooter} visible={isOpenDownload} position="top"
                draggable={false} resizable={false} modal onHide={hideModalDownload}>
                <div className='flex flex-row justify-content-center'>
                    {loading3 && <ProgressSpinner />}
                </div>
            </Dialog>
            <Dialog header={confHeader} footer={confFooter} visible={isOpenConf} position="top"
                draggable={false} resizable={false} modal onHide={hideModalConf}>
            </Dialog>
            <div className='mt-6 flex justify-content-center flex-column align-items-center'>
                <SkeletonTable load={loadPage}>
                    <Tooltip target=".info" className='indigo-tooltip ml-1' />
                    <TreeTable value={rows} rowClassName={rowClassName}
                        // selectionMode='checkbox' selectionKeys={selectedNodeKeys} onSelectionChange={onSelection}
                        scrollable className="card text-xs" paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        >
                        <Column expander  headerStyle={{width: width <= 768 && '2rem'}} bodyStyle={{width: width <= 768 && '2rem'}}></Column>
                        <Column field="NUMBER_ID" header="Documento" headerStyle={{width: width <= 768 && '5rem'}} bodyStyle={{width: width <= 768 && '5rem'}} alignHeader={'left'}></Column>
                        <Column field="NAME" header="Nombre"  headerStyle={{width: width <= 768 && '5rem'}} bodyStyle={{width: width <= 768 && '5rem'}} alignHeader={'left'}></Column>
                        <Column field="LOV_DOCUMENT_TYPE_DESC"  headerStyle={{width: width <= 768 && '5rem'}} bodyStyle={{width: width <= 768 && '5rem'}} header='Tipo' alignHeader={'left'}></Column>
                        <Column header="Acciones"  headerStyle={{width: width <= 768 && '5rem'}} bodyStyle={{width: width <= 768 && '5rem',  textAlign: 'center', overflow: 'visible', alignContent: 'center'}} body={actionBodyTemplate} />
                    </TreeTable>
                </SkeletonTable>
            </div>
        </div>
    )

}

export default Documents